import { render, staticRenderFns } from "./CourseApp.vue?vue&type=template&id=40883962&"
import script from "./CourseApp.vue?vue&type=script&lang=js&"
export * from "./CourseApp.vue?vue&type=script&lang=js&"
import style0 from "./CourseApp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports